import React, { memo, useContext, useEffect, useMemo } from "react";
import styled from "styled-components";
import { MapTools, SEARCH_AREA_STATES, clusterDefaultZoomLvl } from "../constants/WebMap";
import { WebMapContext } from "../pages/sections/web-map/WebMapGoogleMap";
import { LoadMapContext } from "../pages/sections/web-map/LoadWebMap";

const NotifyContainer = styled.div`
  display: ${({ show }) =>
    show ? show : "none"};
  position: relative;
  justify-content: center;
  align-items: center;
  width: ${({ wd }) =>
    wd ? wd : "148px"};
  height: 25px;
  margin: 0 auto;
  background-color: #CCDFD6;
  border: 1px solid #007842;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  cursor: ${({ onClick }) =>
    onClick ? "pointer" : "default"};
  transition: box-shadow 0.3s;
  font: normal normal 600 12px/19px 'Open Sans', sans-serif;
  color: #65716c;
  margin-top: ${({ mt }) =>
    mt ? mt : "0px"};

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  }
`;

const WebMapTopNotifications = ({
  showAreaMsg,
  handleShow,
  canShow = false,
  optrSiteVisible,
  ecoSiteVisible,
  msGeohashVisible,
  ibsVisible
}) => {
  const { mapView } = useContext(LoadMapContext);
  const {
    eyeIcons,
    geohashZoom,
    mapZoomLevel,
    siteZoom,
    mapPlacement,
    appliedFilters
  } = useContext(WebMapContext);

  useEffect(() => {
    if (!canShow || appliedFilters.level) handleShow(SEARCH_AREA_STATES.INIT);
  }, [canShow, showAreaMsg]);

  const showZoomInMsg = useMemo(() => {
    const { adminLevel, marketShare, sites,ibs, ...rest } = eyeIcons;
    // geohashes
    const hasOpenEyeIcon = Object.values(rest).some((value) => value === true);
    if (hasOpenEyeIcon && geohashZoom && mapZoomLevel < geohashZoom) return true;

    // market share
    if (marketShare && msGeohashVisible && geohashZoom && mapZoomLevel < geohashZoom) return true;

    // sites
    if (sites && (ecoSiteVisible || optrSiteVisible) && mapZoomLevel < clusterDefaultZoomLvl) return true;

    // ibs
    if (ibs && ibsVisible && mapZoomLevel < clusterDefaultZoomLvl) return true;
    return false;
  }, [eyeIcons, mapZoomLevel, ecoSiteVisible, optrSiteVisible, geohashZoom, siteZoom, msGeohashVisible, ibsVisible]);

  return (
    <div style={{
      width: mapView === MapTools.SLIDER ? "50%" : "100%",
      float: mapView === MapTools.SLIDER && mapPlacement === 'right' ? "right" : "none"
    }}>
      {showAreaMsg === SEARCH_AREA_STATES.B_C
        ? <NotifyContainer
          show={showAreaMsg === SEARCH_AREA_STATES.B_C ? "flex" : "none"}
          mt={mapView !== null ? '10px' : '0px'}
          onClick={() => handleShow(SEARCH_AREA_STATES.FETCH)}
        >
          <img src={"/assets/search_green.png"} alt="+" style={{ width: "17px", marginRight: "6px" }} />
          Search this area
        </NotifyContainer>
        : <NotifyContainer
          show={showZoomInMsg ? "flex" : "none"}
          mt={mapView !== null ? '10px' : '0px'}
          wd={"330px"}
        >
          <img src={"/assets/zoom_in_green.png"} alt="+" style={{ width: "17px", marginRight: "6px" }} />
          The selected layer is not visible at this zoom level
        </NotifyContainer>}
    </div>
  );
}

export default memo(WebMapTopNotifications);